import React from "react";
import { useDispatch } from "react-redux";
import { logoutAsync } from "../../state/ducks/auth";

interface NavbarProps {}

export const Navbar: React.FC<NavbarProps> = (props) => {
  const dispatch = useDispatch();

  return (
    <nav className="portal-navbar">
      <h1 className="brand">EMMS</h1>
      <span
        className="avatar"
        aria-label="logout"
        onClick={() => {
          dispatch(logoutAsync());
        }}
      >
        Logout
      </span>
    </nav>
  );
};
